import React from "react";
import PropTypes from "prop-types";

const UploadsPage = (props) => {
  return (
    <>
      <div className="container">
        <h3 className="mb-4">Uploads</h3>

        <div className="row row-xs align-items-center mb-4">
          <div className="col-12 col-md-4 col-xl-2 mb-2">
            <input
              className="fin-control fin-control-sm"
              type="search"
              placeholder="Search uploads"
            />
          </div>
          <div className="col-12 col-sm-6 col-md-4 col-xl-2 mb-2">
            <select className="fin-control fin-control-sm">
              <option>Status</option>
              <option>Successfully processed</option>
              <option>Failed</option>
            </select>
          </div>
        </div>

        <table className="table-list table-uploads">
          <thead>
            <tr>
              <th>FILENAME / DATE</th>
              <th>
                SUCCESSFULLY PROCESSED
                <br />/ TOTAL EVENTS COUNT
              </th>
              <th />
            </tr>
          </thead>
          <tbody>
            <tr className="text-small">
              <td data-title="FILENAME">
                <p>
                  small_test_1k_scored_2021-03-17.csv
                  <br />
                  <small className="text-faint">2021-03-17 15:33:37 UTC</small>
                </p>
                Download:{" "}
                <a className="link-color" href="#">
                  Original file
                </a>{" "}
                |{" "}
                <a className="link-color" href="#">
                  Processed file
                </a>
              </td>
              <td data-title="SUCCESSFULLY PROCESSED / TOTAL EVENTS COUNT">
                1000/1000 -{" "}
                <strong className="badge text-success">SUCCESS</strong>
              </td>
              <td className="table-actions text-md-center nowrap">
                {/*<a href="uploads-edit.php" className="btn-transparent btn-icon ml-n2 ml-md-0" data-toggle="tooltip" data-placement="top" title="Edit">*/}
                {/*     <i className="icon-edit"></i>*/}
                {/*   </a>*/}
                <a
                  href=""
                  className="btn-transparent btn-icon"
                  data-tooltip="tooltip"
                  data-placement="top"
                  title="Delete"
                  data-toggle="modal"
                  data-target="#delete-modal"
                >
                  <i className="icon-delete" />
                </a>
              </td>
            </tr>
            <tr className="text-small">
              <td data-title="FILENAME">
                <p>
                  small_test_1k_scored_2021-03-17.csv
                  <br />
                  <small className="text-faint">2021-03-17 15:33:37 UTC</small>
                </p>
                Download:{" "}
                <a className="link-color" href="#">
                  Original file
                </a>{" "}
                |{" "}
                <a className="link-color" href="#">
                  Processed file
                </a>
              </td>
              <td data-title="SUCCESSFULLY PROCESSED / TOTAL EVENTS COUNT">
                998/1000 - <strong className="badge text-error">FAILED</strong>
              </td>
              <td className="table-actions text-md-center nowrap">
                {/* <a href="uploads-edit.php" className="btn-transparent btn-icon ml-n2 ml-md-0" data-toggle="tooltip" data-placement="top" title="Edit">*/}
                {/*  <i className="icon-edit"></i>*/}
                {/*</a>*/}
                <a
                  href=""
                  className="btn-transparent btn-icon"
                  data-tooltip="tooltip"
                  data-placement="top"
                  title="Delete"
                  data-toggle="modal"
                  data-target="#delete-modal"
                >
                  <i className="icon-delete" />
                </a>
              </td>
            </tr>
          </tbody>
        </table>
        <ul className="pagination mt-45">
          <li className="active">
            <span className="current" tabIndex="-1">
              1
            </span>
          </li>
          <li>
            <a href="#" tabIndex="-1">
              2
            </a>
          </li>
          <li>
            <a href="#" tabIndex="-1">
              3
            </a>
          </li>
        </ul>
      </div>
    </>
  );
};

UploadsPage.propTypes = {};

export default UploadsPage;
